import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { invoiceStatuses } from '../../../../helpers/constants';
import { ErrorBlock, SuccessBlock, WaitingBlock } from '../../../Block';
import Loader from '../../../Loader';
import { fetchInvoiceStatus } from '../../../../actions/invoice';
import {
  useCustomTranslation,
  usePromiseWrapper,
  useActions,
} from '../../../../helpers/hooks';

export function DelayedRedirect({ url }) {
  const { t } = useTranslation();

  const [timeout, setTimeout] = useState(5);

  useEffect(() => {
    const interval = setInterval(
      () => setTimeout((t) => (t === 0 ? 0 : t - 1)),
      1000
    );

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (timeout === 0) {
      window.location.assign(url);
    }
  }, [timeout === 0]);

  return (
    <p>
      {t('Invoice.Result.Redirect.WillBe')} {timeout}{' '}
      {t('Invoice.Result.Redirect.Seconds')}
    </p>
  );
}

export function InvoiceCommonResult({ invoice }) {
  const fetchInvoiceStatusAction = useActions(fetchInvoiceStatus, []);

  const [wrappedFetchStatus, statusLoading] = usePromiseWrapper({
    initPromise: fetchInvoiceStatusAction,
    initialState: {
      loading: false,
    },
  });

  const resultData = invoice.result.data;

  useEffect(() => {
    if (resultData.status === invoiceStatuses.inProcess) {
      const interval = setInterval(
        () => (statusLoading ? null : wrappedFetchStatus()),
        10 * 1000
      );

      return () => clearInterval(interval);
    }
  }, [resultData.status]);

  const { t } = useCustomTranslation();

  switch (resultData.status) {
    case invoiceStatuses.success: {
      return (
        <SuccessBlock headerText={t('Invoice.Result.Success')}>
          {resultData.success_url ? (
            <>
              <button
                className="btn"
                onClick={() => window.location.assign(resultData.success_url)}
              >
                {t('Invoice.Result.ToShop')}
              </button>
              <DelayedRedirect url={resultData.success_url} />
            </>
          ) : null}
        </SuccessBlock>
      );
    }
    case invoiceStatuses.fail: {
      return (
        <ErrorBlock headerText={t('Invoice.Result.Fail')}>
          {resultData.failed_url ? (
            <>
              <button
                className="btn"
                onClick={() => window.location.assign(resultData.failed_url)}
              >
                {t('Invoice.Result.ToShop')}
              </button>
              <DelayedRedirect url={resultData.failed_url} />
            </>
          ) : null}
        </ErrorBlock>
      );
    }
    case invoiceStatuses.inProcess: {
      return (
        <WaitingBlock
          headerText={t('Invoice.Result.Waiting.Header')}
          text={t('Invoice.Result.Waiting.Text')}
        >
          {statusLoading ? <Loader /> : null}
          <div className="block__btn-inline">
            <button className="btn btn--white" onClick={wrappedFetchStatus}>
              {t('Invoice.Result.Waiting.Button')}
            </button>

            {resultData.success_url || resultData.failed_url ? (
              <button
                className="btn"
                onClick={() =>
                  window.location.assign(
                    resultData.success_url || resultData.failed_url
                  )
                }
              >
                {t('Invoice.Result.ToShop')}
              </button>
            ) : null}
          </div>
        </WaitingBlock>
      );
    }
    default: {
      return <ErrorBlock headerText={t('DefaultError')} />;
    }
  }
}
